import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import '../../../components_style/doctorComponents/FormsStyle.css'
import FormElementContainer from "../../../components/forms_builder/FormElementContainer";
import CannabisUse from "../../../components/PatientOnboard/CannabisUse";
import * as Yup from "yup";
import Error from "../../../components/single_components/Error";
import IndicationRequest from "../../../components/PatientOnboard/IndicationRequest";
import TargetSymptoms from "../../../components/PatientOnboard/TargetSymptoms";
import UpdateFiles from "../../../components/PatientOnboard/UpdateFiles";
import ImagingBlock from "../../../components/PatientOnboard/ImagingBlock";
import DoctorsReferral from "../../../components/PatientOnboard/DoctorsReferral";
import ShowingReason from "../../../components/PatientOnboard/ShowingReason";




class UseOfCannabisComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 1,
        };
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    onValueChange = (name,value) => {
        this.props.onValueChange(name,value)
    }
    onYesNoValueChange = (name,value) => {
        this.props.onYesNoValueChange(name,value)
    }

    onClickCheckboxes = (name) => {
        this.props.onClickCheckboxes(name)
    }

    onChangeDiagnose = (value,name) => {
        this.props.onChangeDiagnose(value,name)
    }

    onClickAddProducts = (func,value,index) => {
        this.props.onClickAddProducts(func,value,index)
    }

    onClickTargetSymptom = (SymptomsInput,name,id) => {
        this.props.onClickTargetSymptom(SymptomsInput,name,id)
    }
    addDeleteTargetSymptom = (name) => {
        this.props.addDeleteTargetSymptom(name)
    }
    addFileObj = (index,selectedCategory,selectedFile) => {
        this.props.addFileObj(index,selectedCategory,selectedFile)
    }

    deleteUploadedFile=(index) => {
        this.props.deleteUploadedFile(index)
    }
    render() {
        let {t} = this.props
        let {entry} = this.props
        let category=[
            "T3/C15","T5/C10",
            "T10/C2","T10/C10","T15/C3",
             "T5/C5","Other"]
        let categoryOptions=[]
        categoryOptions = category.map(item =>
            <option className={'option-style'} value={item}>{item}</option>)

        return (
            <div  className={'patientForm-box-container'}>

                <FormElementContainer
                    title={t('patient_boarding.ShowingReason')}
                    Component={ShowingReason}
                    rest={{
                        onValueChange:(name,value) => this.onValueChange(name,value) ,
                        entry:this.props.entry,
                        checkboxes:this.props.checkboxes,
                        t:(e) => this.props.t(e),
                        errors:this.props.errors
                    }}/>

                    <FormElementContainer
                    title={t('patient_boarding.symptoms_choose')}
                    Component={TargetSymptoms}
                    rest={{
                        onValueChange:(name,value) => this.onValueChange(name,value) ,
                        entry:this.props.entry,
                        checkboxes:this.props.checkboxes,
                        symptomsList:this.props.symptomsList,
                        symptoms:this.props.symptoms,
                        t:(e) => this.props.t(e),
                        onClickTargetSymptom:(SymptomsInput,name,id) => this.onClickTargetSymptom(SymptomsInput,name,id),
                        addDeleteTargetSymptom:(name) => this.addDeleteTargetSymptom(name),
                        errors:this.props.errors
                    }}/>

                <FormElementContainer
                    title={t('patient_boarding.Imaging_helpful_checks')}
                    Component={ImagingBlock}
                    rest={{
                        onValueChange:(name,value) => this.onValueChange(name,value) ,
                        entry:this.props.entry,
                        t:(e) => this.props.t(e),
                        errors:this.props.errors
                    }}/>

                    <FormElementContainer
                    title={t('patient_boarding.Doctors_Referral')}
                    Component={DoctorsReferral}
                    rest={{
                        onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                        onValueChange:(name,value) => this.onValueChange(name,value) ,
                        entry:this.props.entry,
                        t:(e) => this.props.t(e),
                        errors:this.props.errors
                    }}/>

                <FormElementContainer title={t('patient_boarding.upload_files')}
                                      Component={UpdateFiles}
                                      rest={{
                                          isUploadingFiles:this.props.isUploadingFiles,
                                          onValueChange:(name,value) => this.onValueChange(name,value) ,
                                          addFileObj:(index,selectedCategory,selectedFile) => this.addFileObj(index,selectedCategory,selectedFile),
                                          deleteUploadedFile:(index) => this.deleteUploadedFile(index),
                                          entry:this.props.entry,
                                          addedFilesList:this.props.addedFilesList,
                                          fileForms:this.props.fileForms,
                                          errors:this.props.errors,
                                          t:(e) => this.props.t(e)
                                      }}/>


            </div>


        );
    }
}



const ReferralReasonTab = compose(
    withTranslation(),
)(UseOfCannabisComposed);

export default ReferralReasonTab;
